import palette from './palette.mjs';

export default {
  MuiToggleButtonGroup: {
    root: {
      '&>:first-child': { borderRadius: '8px 0px 0px 8px' },
      '&>:last-child': { borderRadius: '0px 8px 8px 0px' },
      '& .MuiToggleButton-root': {
        height: 36,
        minHeight: 36,
        fontWeight: 500,
        fontSize: 16,
        padding: '10px 16px',
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
        marginRight: 1,
        borderLeft: 'none !important',
        borderRight: 'none !important',
        borderTop: 'none !important',
        borderBottom: 'none !important',
        color: palette.primary.text6,
        whiteSpace: 'nowrap',
        '&:hover': {
          color: palette.primary.contrastText,
          background: 'rgba(255, 255, 255, 0.12)',
        },
      },
      '& .MuiToggleButton-root.Mui-selected': {
        backgroundColor: 'rgba(3, 188, 212, 0.10)',
        color: palette.primary.main,

        '&:hover': {
          backgroundColor: 'rgba(3, 188, 212, 0.10)',
          color: palette.primary.main,
        },
      },
      '& .MuiToggleButton-root.Mui-disabled': {
        color: palette.primary.text6,
        opacity: 0.4,
        pointerEvents: 'all',
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
        '&:hover': {
          color: palette.primary.text6,
          backgroundColor: 'rgba(255, 255, 255, 0.08)',
        },
        '&.Mui-selected': {
          color: palette.primary.contrastText,
        },
      },
      '& .MuiToggleButton-root.MuiToggleButton-sizeLarge': {
        height: 40,
        minHeight: 40,
        fontWeight: 500,
        fontSize: 18,
        padding: '11px 16px',
      },
      '& .MuiToggleButton-root.MuiToggleButton-sizeMedium': {
        height: 36,
        minHeight: 36,
        fontWeight: 500,
        fontSize: 16,
        padding: '10px 16px',
      },
      '& .MuiToggleButton-root.MuiToggleButton-sizeSmall': {
        height: 32,
        minHeight: 32,
        fontWeight: 500,
        fontSize: 16,
        padding: '8px 12px',

        '& .i-icon, & .i-icon svg': {
          width: '20px !important',
          height: '20px !important',
        },
      },
      '& .MuiToggleButton-label': {
        textTransform: 'none',
      },
    },
  },
};
